<template>
    <div class="file-list">
        <b>Product Brochure Uploads:</b>
        <li v-for="(item, index) in items" :key="index">
            <a :href="createDownloadUrl(item.FullPath)" target="_blank"> {{ item.FileName }} </a>
        </li>
    </div>
</template>

<script>

export default {

  name: "FileList",

  props: {
    fileUploadJson: { type: String, required: true },
  },

  data () {
    return {
      items: JSON.parse(this.fileUploadJson)
    }
  },

  methods: {
    createDownloadUrl(fullPath) {
        console.log(fullPath);
        const parts = fullPath.split("/");
        const lastGuid = parts[parts.length - 1]
        let result = "https://member.mafsi.org/file/custom-field/" + lastGuid;
        return result;
    }
  }

};


</script>

<style scoped>

    .file-list {
    }

</style>